import { render, staticRenderFns } from "./NeqasSampleReportsModal.vue?vue&type=template&id=b1307a8a"
import script from "./NeqasSampleReportsModal.vue?vue&type=script&lang=js"
export * from "./NeqasSampleReportsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports